module.exports = __webpack_public_path__ + "static/media/team_2x.8b2e439d.png";